import React, { Fragment } from "react";
import styled from "styled-components";
import _ from "lodash";
import num from "numeral";
import { connect } from "formik";
import { Grid } from "@material-ui/core";
import { AutoCompleteInput, TextInput, MoneyInput } from "components/Global/FastFormikMaterial";

import ViewOnlyDiv from "./ViewOnlyDiv";
import LateralField from "./LateralField";

const StyledAutoCompleteInput = styled(AutoCompleteInput)`
&&&&{
  height:33px;
}
`;

const StyledMidLabel = styled(Grid)`
align-content: center;
justify-content: center;
font-family: 'Roboto-Regular', 'Roboto';
font-weight: normal;
font-size: 17px;
color: rgb(51, 51, 51);
`;

const SideLabelMoneyAndAutoCompleteWithRefInput = ({ label, midLabel, moneyFieldName, ddlFieldName, refFieldName, placeholder, formik, isDisabled, hasBorder, options, selectName, selectValue, shouldHideForQuote, ...otherProps }) => {
  if (shouldHideForQuote) {
    return null;
  }

  const { values } = formik;
  if (!selectName) {
    selectName = "name";
  }
  const valMoney = _.get(formik.values, moneyFieldName);
  const val = _.get(formik.values, ddlFieldName);
  let selectVal = _.find(options, { [selectValue]: val });
  if (!selectVal) {
    selectVal = { [selectName]: "--" };
  }
  const refVal = _.get(formik.values, refFieldName || `${moneyFieldName}Ref`);

  return (
    <LateralField label={label} hasBorder={hasBorder}>
      {isDisabled && (
        <Grid container item spacing={16}>
          <Grid container item xs={6}>
            <Grid item xs={4}>
              <ViewOnlyDiv>{valMoney ? num(valMoney).format("$0,0") : ""}</ViewOnlyDiv>
            </Grid>

            <StyledMidLabel container item xs={1}>
              {midLabel}
            </StyledMidLabel>

            <Grid item xs={6}>
              <ViewOnlyDiv>{selectVal[selectName]}</ViewOnlyDiv>
            </Grid>
          </Grid>
          <Grid item xs={4} />
          <Grid item xs={2}>
            <ViewOnlyDiv placeholder="No reference">{refVal}</ViewOnlyDiv>
          </Grid>
        </Grid>)}
      {!isDisabled && (
        <Grid container item spacing={16}>
          <Grid container item xs={6}>
            <Grid item xs={4}>
              <MoneyInput
                fullWidth
                fieldName={moneyFieldName}
                placeholder={placeholder}
                {...otherProps}
              />
            </Grid>

            <StyledMidLabel container item xs={2}>
              {midLabel}
            </StyledMidLabel>

            <Grid item xs={6}>
              <StyledAutoCompleteInput
                formik={formik}
                fieldName={ddlFieldName}
                options={options}
                selectName={selectName}
                selectValue={selectValue}
                {...otherProps}
              />
            </Grid>

          </Grid>
          <Grid item xs={4} />
          <Grid item xs={6}>
            <TextInput
              fullWidth
              fieldName={refFieldName || `${moneyFieldName}Ref`}
              placeholder="Add a reference"
              {...otherProps}
            />
          </Grid>
        </Grid>)}
    </LateralField>
  );
};
export default connect(SideLabelMoneyAndAutoCompleteWithRefInput);
